import { FC } from "react"
import { useTranslation } from 'react-i18next'
import { A11y, Autoplay, Scrollbar } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import '../../../node_modules/swiper/swiper-bundle.min.css'
import '../../../node_modules/swiper/modules/scrollbar.min.css'
import '../../../node_modules/swiper/modules/autoplay.min.css'
import { useComponentVisibilityStore } from "@shared/store/useComponentVisibilityStore"
import Slide from "@widgets/slider/slide/Slide"

import { SLIDES } from "./constants.tsx"
import styles from "./slider.module.css"


const Slider: FC = () => {
    const { ready } = useTranslation()
    const { setIsSliderVisibleOnMobile } = useComponentVisibilityStore()

    const handleClick = () => {
        setIsSliderVisibleOnMobile(false)
    }

    if (!ready) return null

    return (
        <div className={styles.swiperContainer}>
            <div className={styles.swiper}>
                <Swiper
                    style={{ width: '100%' }}
                    modules={[Scrollbar, A11y, Autoplay]}
                    slidesPerView={1}
                    scrollbar={{
                        draggable: true,
                        horizontalClass: styles.scrollbar,
                        dragClass: styles.draggableEL,
                    }}
                    autoplay={{
                        delay: 4000,
                    }}
                    loop={true}
                    wrapperClass={styles.wrapper}
                >
                    {SLIDES?.map((slide, idx) => (
                        <SwiperSlide key={idx}>
                            <Slide
                                {...slide}
                                onButtonClick={handleClick}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default Slider
